import { useCallback } from "react";
import { useSelector } from "react-redux";
import { selectRepresentativePermissions } from "@/features/auth/store/sessionSlice";
import type {
  PermissionFeatureCode,
  RepresentativePermissionCode,
} from "@/shared/types/representativePermissions";
import type { RootState } from "@/store";

export const useRepresentativePermissions = () => {
  const permissions = useSelector((state: RootState) =>
    selectRepresentativePermissions(state),
  );

  const hasPermission = useCallback(
    (code: RepresentativePermissionCode): boolean => !!permissions?.[code],
    [permissions],
  );

  const canRead = useCallback(
    (featureCode: PermissionFeatureCode): boolean => hasPermission(`${featureCode}:read`),
    [hasPermission],
  );

  const canManage = useCallback(
    (featureCode: PermissionFeatureCode): boolean => hasPermission(`${featureCode}:manage`),
    [hasPermission],
  );

  return {
    permissions,
    hasPermission,
    canRead,
    canManage,
    canManageRoles: canManage("service_representative_roles"),
    canReadRoles: canRead("service_representative_roles"),
  };
};
